// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","571":"b637e9a5","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"884cd980440cefb5dadf","571":"28ebdc8dadf286d6afb7","678":"9ff4c9733f344b68bca9","883":"0a7471df4d0bd8c11501"}[chunkId] + ".js";
};